import pick from 'lodash.pick';
import { useContext } from 'react';

import FirebaseAuthContext from './firebase-auth-context';

export const useFirebaseAuth = () => {
  const state = useContext(FirebaseAuthContext);
  const next = pick(state, [
    'isAdmin',
    'isAnonymous',
    'isReady',
    'isSignedIn',
    'providerId',
    'user',
  ]);

  // console.log('next', next);

  return next;
};

export default useFirebaseAuth;
